module.exports = __webpack_public_path__ + "vue_assets/img/img_membership_commercial.ebcd2114.png";